module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"megatrend":"Mega-Trend","macrotrendsOfMegatrend":"Macro-Trends des gleichen Mega-Trend","relatedMacrotrends":"Ähnliche Macro-Trends"},"en":{"megatrend":"Mega-trend","macrotrendsOfMegatrend":"Macro-trends of the same Mega-trend","relatedMacrotrends":"Related Macro-trends"}}')
  delete Component.options._Ctor
}
